export default function facebookShare(urlToShare) {
    const encodedUrl = encodeURIComponent(urlToShare);

    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

    window.open(facebookShareUrl, '_blank', 'width=600,height=400');
}

export function instagramShare(urlToShare) {
    const encodedCaption = encodeURIComponent("Check out this awesome content on my website!");
    const encodedUrl = encodeURIComponent(urlToShare);
    const instagramShareUrl = `https://www.instagram.com/create/details/?caption=${encodedCaption}&url=${encodedUrl}`;

    const confirm = window.confirm("Unfortunately, Instagram does not allow sharing from a website. You'll need to manually create a post. We would really appreciate the love. Click OK to open Instagram.");

    if (!confirm) {
        return;
    }

    window.open(instagramShareUrl, '_blank', 'width=600,height=400');
}
